import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, CheckSquare, Share2, Download } from "lucide-react";
import logo from "../../../assets/images/logo_truklex.svg"
export default function IftaHeader({
  iftaDetails,
  completed,
  setCompleted,
  generatePDF,
  loadingPDF,
  vehicle,
  params,
  getQuarterDateRange,
}) {
  return (
    <div
      className="d-flex flex-row bg_custome_report justify-content-between align-items-center mb-4 pb-3 border-bottom gap-3"
      style={{
          // prevent shrinking on small screens
        margin: "0 auto", // center horizontally
        overflowX: "auto" // optional: allow horizontal scroll if screen smaller than 1200px
      }}
    >
      {/* Left Section - Logo */}
      <div className="logo">
        <img
          src={logo}
          alt="Truklex Logo"
          style={{ height: 50, width: "auto" }}
        />
      </div>

      {/* Details Section */}
      <div className="d-flex align-items-center gap-2 pt-5 custome-padding_repo">
        <div>
          <h5 className="fw-bold mb-1">
            TRK-{iftaDetails?.id?.toString()?.padStart(3, "0")} - {iftaDetails?.year} Q{iftaDetails?.quarter} 
          </h5> 
          <p className="text-white font-fw" style={{fontWeight:'medium'}}>{vehicle || "All Fleet"}</p>
        </div>
      </div>

      {/* Optional Action Buttons (Example) */}
      
    </div>
  );
}
